import React from 'react';
import { Container} from "reactstrap";

function Error(props) {
    return(
        <div>
            <Container>
                <div className='not-founded'>
            Sorry, Page not found
            </div>
            </Container>
            </div>
    );
}

export default Error;